import styled, { css } from 'styled-components';

interface RootProps {
  $isActive?: boolean;
  $isInteractive?: boolean;
  $size?: 'sm' | 'md';
}

export const Root = styled.span<RootProps>`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  border-radius: 999px;
  font-weight: 500;

  ${({ $size = 'md' }) =>
    $size === 'sm'
      ? css`
          height: 22px;
          padding: 0 8px;
          font-size: 11px;
        `
      : css`
          height: 26px;
          padding: 0 10px;
          font-size: 12px;
        `}

  ${({ theme: { colors = {} } }) => css`
    background: ${colors.surfaceContainerHigh ?? '#292932'};
    border: 1px solid ${colors.outlineVariant ?? '#464555'};
    color: ${colors.onSurface ?? '#E4E1ED'};
  `}

  ${({ $isInteractive, theme: { colors = {} } }) =>
    $isInteractive &&
    css`
      cursor: pointer;
      &:hover {
        background: ${colors.surface ?? '#13131B'};
      }
    `}

  ${({ $isActive, theme: { colors = {} } }) =>
    $isActive &&
    css`
      background: color-mix(in oklch, ${colors.primary ?? '#C1C1FF'} 18%, transparent);
      border-color: color-mix(in oklch, ${colors.primary ?? '#C1C1FF'} 50%, transparent);
      color: ${colors.primary ?? '#C1C1FF'};
    `}

  & > svg,
  & > .material-symbols-rounded {
    font-size: 12px;
    width: 12px;
    height: 12px;
  }
`;

export const Count = styled.span<{ $isActive?: boolean }>`
  font-size: 10px;
  font-weight: 500;
  margin-left: 2px;
  ${({ $isActive, theme: { colors = {} } }) =>
    $isActive
      ? css`
          color: ${colors.primary ?? '#C1C1FF'};
          opacity: 0.8;
        `
      : css`
          color: ${colors.onSurfaceVariant ?? '#C7C4D7'};
        `}
`;
